export default __webpack_public_path__ + "static/media/NFD_Minting_Guide1024_11.d5631c08.png";